module.exports = __webpack_public_path__ + "static/img/ISO9001_Shulin.9a46fa10.jpg";